import clsx from 'clsx';
import { ReactNode, forwardRef } from 'react';

interface SectionHeaderProps
  extends React.ButtonHTMLAttributes<HTMLHeadingElement> {
  className?: string;
  children: ReactNode;
}

const SectionHeader = forwardRef<HTMLHeadingElement, SectionHeaderProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <h2
        className={clsx('text-3xl font-semibold md:text-5xl', className)}
        ref={ref}
        {...props}
      >
        {children}
      </h2>
    );
  },
);

// Add a display name for better debugging
SectionHeader.displayName = 'SectionHeader';

export default SectionHeader;
